var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mt-5"},[_c('v-col',{attrs:{"cols":"12","md":"8","offset-md":"2","lg":"6","offset-lg":"3"}},[_c('login-card',{on:{"success":_vm.onLoginSuccess}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }